import { Component, OnInit } from '@angular/core';
import { StateService } from '@uirouter/core';
import { SimDataService } from '../../services/sim-data.service';
import { Observable, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { DatePipe } from '@angular/common';

import { SimUsage } from '../../models/sim-usage';
@Component({
  selector: 'app-sim-overview-details',
  template: require('./sim-overview-details.component.html'),
  styles: [require('./sim-overview-details.component.sass')]
})
export class SimOverviewDetailsComponent implements OnInit {

  projectId: number;
  iccid: string;
  from: Date; 
  to: Date;

  sim$: Observable<SimUsage>;
  yearRange: string;
  
  constructor(
    private $state: StateService,
    private simDataService: SimDataService,
    private datePipe: DatePipe
  ) { 
    this.projectId = this.$state.params && this.$state.params.projectId;
    this.iccid = this.$state.params && this.$state.params.iccid;

    const from = this.$state.params && this.$state.params.from;
    const to = this.$state.params && this.$state.params.to;

    this.from = new Date(Date.parse(from));
    this.to = new Date(Date.parse(to));

    const sim$ = this.simDataService.getSimUsageDetails(this.projectId, this.iccid, from, to);
    const operators$ = this.simDataService.getAllOperators(this.projectId);

    this.sim$ = combineLatest([sim$, operators$]).pipe(
      map(([sim, operators]) => {
        const operator = operators.find(operator => operator.code === String(sim.simConfig.operatorCode));
        return {
          ...sim,
          simConfig: {
            ...sim.simConfig,
            operator: operator && operator.network
          }
        }
      }))

     const maxYear = new Date().getFullYear();
     const minYear = maxYear - 5;
     this.yearRange = `${minYear}:${maxYear}`
  }

  ngOnInit(): void {
  }

  backToOverview() {
    this.$state.go('sim-overview', {
      projectId: this.projectId
    })
  }

  onUpdatePeriod(period: {from: Date, to: Date}) {
    this.$state.go('sim-overview-detail', {
      projectId: this.projectId, 
      iccid: this.iccid,
      from: this.datePipe.transform(period.from, "yyyy-MM-dd'T'HH:mm:ssZZZZZ"),
      to: this.datePipe.transform(period.to, "yyyy-MM-dd'T'HH:mm:ssZZZZZ")
    });
  }
}
